import { extractValidationDetailErrors, extractValidationErrors } from '@/helpers/api'

/**
 * This mixin provides the getErrorsForFields function and defines the errors array in data.
 */
export default {
  data () {
    return {
      errorsMixin_errors: [],
    }
  },
  created () {
    this.$set(this, 'errorsMixin_errors', [])
  },

  methods: {
    clearErrors () {
      this.errorsMixin_errors = []
    },
    extractErrors (exception) {
      this.errorsMixin_errors = extractValidationErrors(exception)
    },
    extractDetailErrors (exception) {
      this.errorsMixin_errors = extractValidationDetailErrors(exception)
    },
    getErrorsForField (field) {
      return this.errorsMixin_errors.filter(function (error) {
        return error.source === 'data/attributes/' + field
      })
    },
    getErrorsForArrayField (field) {
      return this.errorsMixin_errors.filter(function (error) {
        return error.source.includes('data/attributes/' + field)
      })
    },
    getErrorsForArrayFields (fields) {
      return this.errorsMixin_errors.filter(function (error) {
        return fields.some(field => error.source.includes('data/attributes/' + field))
      })
    },
  },
}
